import { FEATURES, hasFeature } from '@/features/feature-flags';
import { useAppShortcut } from '@/features/shortcuts';
import { sandboxTerminalPanelStore } from '@/features/sprites/sandbox-terminal-panel.store';
import { inElectron } from '@/utils/capabilities';

/** True when keyboard focus is inside the local terminal's xterm. */
function isTerminalFocused(): boolean {
  const panel = document.querySelector('[data-testid="local-terminal-panel"]');
  return !!panel && panel.contains(document.activeElement);
}

/**
 * ctrl+` (VS Code semantics): hidden -> show and focus; visible but unfocused ->
 * focus; focused -> hide. Hiding keeps the shell alive; see the panel store.
 * Registered once in MainLayout so it works on every route.
 */
export function useRegisterToggleTerminalHotkey() {
  useAppShortcut(
    'terminal.toggle',
    () => {
      if (!inElectron() || !hasFeature(FEATURES.LOCAL_TERMINAL)) return;
      if (!sandboxTerminalPanelStore.isLocalOpen) {
        // LocalTerminalPanel focuses the shell once the dock is visible
        sandboxTerminalPanelStore.openLocal();
        return;
      }
      if (isTerminalFocused()) {
        sandboxTerminalPanelStore.hideLocal();
      } else {
        sandboxTerminalPanelStore.focusLocal();
      }
    },
    {
      preventDefault: true,
      // xterm's input is a <textarea>; the composer is contenteditable
      enableOnFormTags: true,
      enableOnContentEditable: true,
    }
  );
}
